/** 
 * 计时器
 * */
export let EXPIR_TIME_CONST={
    MINUTES :5,
    TIPS :"Timeout in",
    TITLE: "《》FPX"
}
/**
 * 倒计时：Return To Fpx
 */
export let EXPIR_SECOND = 10;


//////////////////
// WEBPACK FOOTER
// ./static/expir/ExpirTime.js
// module id = null
// module chunks = 